'use strict';

import axios from 'axios';

let choices = document.querySelectorAll('[data-product-finder-choice]') || null,
	priceContainer = document.querySelector('[data-product-finder-price]') || null,
	submitButton = document.querySelector('[data-product-finder-button]') || null,
	finderForm = document.querySelectorAll('#product-finder-form .form-control') || null,
	api = window.api || null,
	oldPrice,
	newPrice,
	preselectedPrice = 0;

// IE forEach fix: converting NodeList to Array
choices = Array.prototype.slice.call(choices);
finderForm = Array.prototype.slice.call(finderForm);

function updatePrice(event) {
	newPrice = (Number(event.target.dataset.productFinderValue) + Number(oldPrice) - Number(preselectedPrice)).toFixed(2);
	priceContainer.innerHTML = priceContainer.innerHTML.replace(/(\d+(\.\d+)?)/g, newPrice);
}

function nextStep() {
	if (api) {
		if (choices) {
			axios.post(api.urls.productFinderNextLink, {
				value: newPrice
			}).then(function(response) {
				console.log(response);
			}).catch(function(error) {
				console.log(error);
			});
		}

		if (finderForm) {
			let dto = {};

			finderForm.forEach(function(item) {
				dto['"' + item.id + '"'] = encodeURI(item.value);
			});

			axios.post(api.urls.productFinderNextLink, dto).then(function(response) {
				console.log(response);
			}).catch(function(error) {
				console.log(error);
			});
		}
	} else {
		console.log('call to backend, value = ' + newPrice || finderForm);
	}
}

if (choices && priceContainer) {
	choices.forEach(function(item) {
		item.addEventListener('click', updatePrice);

		if (item.checked) {
			preselectedPrice = item.dataset.productFinderValue;
		}
	});

	oldPrice = priceContainer.innerHTML.match(/(\d+(\.\d+)?)/g)[0];
}

if (submitButton) {
	submitButton.addEventListener('click', nextStep);
}
